export enum AuthRegistrationType {
  Orcid = 'ORCID',
  Validation = 'VALIDATION_',
}
